var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chinaecharts"},[_c('div',{ref:"mapChart",attrs:{"id":"mapChart"}})])}
var staticRenderFns = []

export { render, staticRenderFns }